import React, { useRef, useState } from 'react';

export default function ListDivider({ width, maximum, onResize, onCommit }) {
  const gesture = useRef(null);
  const [dragging, setDragging] = useState(false);
  const finish = (e) => {
    if (!gesture.current) return;
    gesture.current = null;
    setDragging(false);
    onCommit();
    if (e.currentTarget.hasPointerCapture(e.pointerId))
      e.currentTarget.releasePointerCapture(e.pointerId);
  };
  return (
    <div
      role='separator'
      tabIndex={0}
      aria-label='调整记录列表宽度'
      aria-orientation='vertical'
      aria-valuemin={200}
      aria-valuemax={maximum}
      aria-valuenow={width}
      className={`trace-divider ${dragging ? 'dragging' : ''}`}
      title='拖拽调整宽度；方向键调整，双击恢复默认'
      onPointerDown={(e) => {
        if (e.button !== 0) return;
        e.preventDefault();
        gesture.current = { x: e.clientX, width };
        e.currentTarget.setPointerCapture(e.pointerId);
        setDragging(true);
      }}
      onPointerMove={(e) => {
        if (gesture.current)
          onResize(gesture.current.width + e.clientX - gesture.current.x);
      }}
      onPointerUp={finish}
      onPointerCancel={finish}
      onLostPointerCapture={() => {
        gesture.current = null;
        setDragging(false);
      }}
      onDoubleClick={() => onResize(260, true)}
      onKeyDown={(e) => {
        const values = {
          ArrowLeft: width - 20,
          ArrowRight: width + 20,
          Home: 200,
          End: maximum,
        };
        if (values[e.key] !== undefined) {
          e.preventDefault();
          onResize(values[e.key], true);
        }
      }}
    />
  );
}
